/**
 * NativeSearchBar - iOS Style Search Bar
 * Replaces heavy search inputs with native iOS look
 */

import { Filter, X } from 'lucide-react';

interface NativeSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  onFocus?: () => void;
  onBlur?: () => void;
  autoFocus?: boolean;
  className?: string;
}

export default function NativeSearchBar({
  value,
  onChange,
  placeholder = 'Cerca...',
  onFocus,
  onBlur,
  autoFocus = false,
  className = '',
}: NativeSearchBarProps) {
  const handleClear = () => {
    onChange('');
  };

  return (
    <div 
      className={`relative ${className}`}
    >
      <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
        <Filter className="w-5 h-5 text-[var(--ios-gray)]" />
      </div>
      
      <input
        type="text"
        value={value}
        data-testid="search-input"
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
        autoFocus={autoFocus}
        placeholder={placeholder}
        className="w-full h-11 pl-10 pr-10 bg-[var(--ios-light-gray-3)] rounded-lg text-[17px] text-[var(--ios-black)] focus:outline-none placeholder:text-[var(--ios-gray)]"
        style={{
          WebkitAppearance: 'none',
          appearance: 'none',
        }}
      />
      
      {value && (
        <button
          onClick={handleClear}
          className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center active:opacity-50 rounded-full"
          style={{ minWidth: '44px', minHeight: '44px' }}
        >
          <div className="w-5 h-5 bg-[var(--ios-gray)] rounded-full flex items-center justify-center">
            <X className="w-3 h-3 text-white" />
          </div>
        </button>
      )}
    </div>
  );
}
